import Vue from 'vue'
import axios from 'axios'
import '@/_commonMixin.js'
import App from '@/pages/app/App.vue'
import { createStore } from '@/_vuexStore.js'

Vue.config.productionTip = process.env.NODE_ENV
Vue.prototype.$http = axios

const store = createStore()

vm = new Vue({
    store,
    render: h => h(App),
}).$mount('#app')
